/**
 * @generated SignedSource<<b3e9575659026896f55c7d5ece66b7f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobScheduleStatusEnum = "AHEAD" | "DELAYED" | "ON_TIME";
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
export type ORConsoleDetailQuery$variables = {
  surgeryId: string;
};
export type ORConsoleDetailQuery$data = {
  readonly surgery: {
    readonly actualStartTime: any | null | undefined;
    readonly actualStopTime: any | null | undefined;
    readonly estimatedStopTime: any | null | undefined;
    readonly id: string;
    readonly location: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
    readonly plannedStart: any | null | undefined;
    readonly plannedStop: any | null | undefined;
    readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
    readonly status: JobStatusEnum | null | undefined;
    readonly turnover: {
      readonly " $fragmentSpreads": FragmentRefs<"EventPanel" | "TimerContentPanelFragment">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"EventPanel" | "ORConsoleDetailHeaderFragment" | "TimerContentPanelFragment">;
  } | null | undefined;
};
export type ORConsoleDetailQuery = {
  response: ORConsoleDetailQuery$data;
  variables: ORConsoleDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "surgeryId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "surgeryId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStart",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStop",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduleStatus",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStartTime",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStopTime",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStopTime",
  "storageKey": null
},
v11 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TimerContentPanelFragment"
},
v12 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "EventPanel"
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Durations",
  "kind": "LinkedField",
  "name": "durations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dynamicDurationMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDurationMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "differenceVsPlannedStopMinutes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateSource",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStartTime",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v17 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "EstimateConnection",
  "kind": "LinkedField",
  "name": "estimates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EstimateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Estimate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "insertedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "storageKey": "estimates(first:20)"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Template",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "EventType",
  "kind": "LinkedField",
  "name": "eventTypes",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameI18nKey",
      "storageKey": null
    },
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blockedReason",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "happenedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "events(first:20)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ORConsoleDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Surgery",
        "kind": "LinkedField",
        "name": "surgery",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ORConsoleDetailHeaderFragment"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Turnover",
            "kind": "LinkedField",
            "name": "turnover",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ORConsoleDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Surgery",
        "kind": "LinkedField",
        "name": "surgery",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "patientMrn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Turnover",
            "kind": "LinkedField",
            "name": "turnover",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  (v13/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v5/*: any*/),
                  (v14/*: any*/),
                  (v8/*: any*/),
                  (v15/*: any*/),
                  (v4/*: any*/),
                  (v17/*: any*/),
                  (v7/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "type": "Job",
                "abstractKey": "__isJob"
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "type": "Job",
            "abstractKey": "__isJob"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "215413e9b66e2b1d2e77328a9a0430d7",
    "id": null,
    "metadata": {},
    "name": "ORConsoleDetailQuery",
    "operationKind": "query",
    "text": "query ORConsoleDetailQuery(\n  $surgeryId: ID!\n) {\n  surgery(id: $surgeryId) {\n    id\n    name\n    plannedStart\n    plannedStop\n    status\n    scheduleStatus\n    actualStartTime\n    actualStopTime\n    estimatedStopTime\n    location {\n      name\n      id\n    }\n    ...TimerContentPanelFragment\n    ...EventPanel\n    ...ORConsoleDetailHeaderFragment\n    turnover {\n      ...TimerContentPanelFragment\n      ...EventPanel\n      id\n    }\n  }\n}\n\nfragment EventCardFragment on Event {\n  id\n  happenedAt\n}\n\nfragment EventPanel on Job {\n  __isJob: __typename\n  id\n  eventTypes {\n    id\n    name\n    nameI18nKey\n    category\n    order\n    enabled\n    blockedReason\n  }\n  events(first: 20) {\n    ...EventPanelListFragment_event\n  }\n}\n\nfragment EventPanelListFragment_event on EventConnection {\n  edges {\n    node {\n      id\n      happenedAt\n      type {\n        id\n      }\n      ...EventCardFragment\n    }\n  }\n}\n\nfragment ORConsoleDetailHeaderFragment on Surgery {\n  name\n  patientMrn\n  plannedStart\n}\n\nfragment TimerContentLeftDetailsFragment on Job {\n  __isJob: __typename\n  status\n  durations {\n    dynamicDurationMinutes\n  }\n  actualStopTime\n  estimatedStopTime\n  plannedStop\n  estimateSource\n}\n\nfragment TimerContentPanelFragment on Job {\n  __isJob: __typename\n  status\n  ...TimerContentLeftDetailsFragment\n  ...TimerContentRightDetailsFragment\n  ...TimerContentStatusBadgeFragment\n  ...TimerContentUpdateInputFragment\n}\n\nfragment TimerContentRightDetailsFragment on Job {\n  __isJob: __typename\n  status\n  durations {\n    dynamicDurationMinutes\n    plannedDurationMinutes\n  }\n  actualStartTime\n  actualStopTime\n  estimatedStartTime\n  estimatedStopTime\n  plannedStart\n  plannedStop\n  estimates(first: 20) {\n    edges {\n      node {\n        id\n        estimate\n        insertedAt\n      }\n    }\n  }\n}\n\nfragment TimerContentStatusBadgeFragment on Job {\n  __isJob: __typename\n  scheduleStatus\n  durations {\n    differenceVsPlannedStopMinutes\n  }\n}\n\nfragment TimerContentUpdateInputFragment on Job {\n  __isJob: __typename\n  id\n  status\n  template {\n    category\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "12c39b800a9e6203d1fdd1f037a3673f";

export default node;
